import { render, staticRenderFns } from "./ViewLevelWrapper.ts.vue?vue&type=template&id=61823b06"
import script from "./ViewLevelWrapper.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewLevelWrapper.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ViewLevelWrapper.ts.vue?vue&type=style&index=0&id=61823b06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports